"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WithSignup = _interopRequireDefault(require("./WithSignup"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable react/jsx-one-expression-per-line */


var translations = {
  en: {
    title: 'Sign In',
    scan: 'If you already have an ArcBlock account, scan with your ABT Wallet to login',
    confirm: 'Confirm login in your ABT Wallet',
    success: 'Sign in successfully'
  },
  zh: {
    title: '登录',
    scan: '如果你已经安装 ABT 钱包并且创建了个人账户，请直接扫码登录',
    confirm: '在 ABT 钱包中确认登录',
    success: '登录成功'
  }
};

function LoginAuth(props) {
  var locale = props.locale;
  var tmp = {
    messages: translations[locale] || translations.en
  };
  Object.assign(tmp, props);
  return _react["default"].createElement(_WithSignup["default"], tmp);
}

LoginAuth.propTypes = {
  locale: _propTypes["default"].oneOf(['en', 'zh'])
};
LoginAuth.defaultProps = {
  locale: 'en'
};

var _default = (0, _styles.withTheme)(LoginAuth);

exports["default"] = _default;